import files from "../data/packFiles.json";

const FILES = new Set(files);

const ALIAS = {
  "waves of poseidon": "waves-of-posedion",
  "wave of poseidon": "waves-of-posedion",
};

function fold(value = "") {
  return String(value)
    .toLocaleLowerCase("en-US")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['’]/g, "")
    .trim();
}

function slugify(name = "") {
  return fold(name)
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function href(file) {
  return `/tiles/pack/${file}.webp?v=2`;
}

export function packTile(name = "") {
  const key = fold(name);
  if (ALIAS[key] && FILES.has(ALIAS[key])) return href(ALIAS[key]);
  const slug = slugify(name);
  return FILES.has(slug) ? href(slug) : "";
}
